import React from 'react';

const LogoutSuccessSVG = () => (
  <svg
    width="125"
    height="125"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="9" className="logout-success-svg" />
    <path
      d="M16.4525 9L11.75 13.82L9.54667 11.7317L8 13.28L11.75 16.9167L18 10.5475L16.4525 9Z"
      fill="white"
    />
  </svg>
);

const EmailSuccess = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="48" cy="48" r="48" fill="#007E33" />
    <path
      d="M54.25 63L47.1667 55.9167L49.5 53.5833L54.25 58.3333L63.6667 48.9167L66 51.25L54.25 63ZM47.6667 44.6667L61 36.3333H34.3333L47.6667 44.6667ZM47.6667 48L34.3333 39.6667V56.3333H42.9167L46.25 59.6667H34.3333C33.4167 59.6667 32.6319 59.3403 31.9792 58.6875C31.3264 58.0347 31 57.25 31 56.3333V36.3333C31 35.4167 31.3264 34.6319 31.9792 33.9792C32.6319 33.3264 33.4167 33 34.3333 33H61C61.9167 33 62.7014 33.3264 63.3542 33.9792C64.0069 34.6319 64.3333 35.4167 64.3333 36.3333V43.5833L61 46.9167V39.6667L47.6667 48Z"
      fill="white"
    />
  </svg>
);

const EmailSVG = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="48" cy="48" r="48" className="logout-success-svg" />
    <path
      d="M54.25 63L47.1667 55.9167L49.5 53.5833L54.25 58.3333L63.6667 48.9167L66 51.25L54.25 63ZM47.6667 44.6667L61 36.3333H34.3333L47.6667 44.6667ZM47.6667 48L34.3333 39.6667V56.3333H42.9167L46.25 59.6667H34.3333C33.4167 59.6667 32.6319 59.3403 31.9792 58.6875C31.3264 58.0347 31 57.25 31 56.3333V36.3333C31 35.4167 31.3264 34.6319 31.9792 33.9792C32.6319 33.3264 33.4167 33 34.3333 33H61C61.9167 33 62.7014 33.3264 63.3542 33.9792C64.0069 34.6319 64.3333 35.4167 64.3333 36.3333V43.5833L61 46.9167V39.6667L47.6667 48Z"
      fill="white"
    />
  </svg>
);

export { LogoutSuccessSVG, EmailSuccess, EmailSVG };
